import Vue from 'vue';

import { bootstrapApplication } from './bootstrap';

const app = bootstrapApplication(Vue);

app.$mount('#app');
